/*eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import { default as PanoModule } from '../../../legacy/panorama/PanoPlayer'

const EventEmitter = require('eventemitter3')

const CursorState = {
    GRAB: 'grab',
    GRABBING: 'grabbing',
}

const panoContainer = {
    position: 'relative',
    width: '100%',
    // 175 because the bottom thumbnail scroll is 137 in height and the close button is 38 in height //
    // height: props => (props.fullScreen ? 'auto' : 'calc(100% - 175px)'),
    height: 'calc(100% - 175px)',
    overflow: 'hidden',
    display: 'inline-block',
    '@media screen and (maxWidth : 1200px)': {
        height: 'calc(100% - 56px)',
    },
}

const PanoPlayer = React.forwardRef((props, ref) => {
    const { options, play, changeMode, fullScreen, changeFullScreen, children, changePanoFullScreen } = props
    const [cursor, setCursor] = useState(CursorState.GRAB)
    const [resize, setResize] = useState(null)

    const panoPlayer = useRef(null)

    const handleOnClick = () => {
        setCursor(CursorState.GRABBING)
    }

    const setAutoRotate = ({ auto, speed }) => panoPlayer?.current?.setAutoRotate(auto, speed)

    const setPanoViewer = (width, height) => {
        const handleViewReady = () => {
            setAutoRotate({
                auto: true,
                speed: 0.1,
            })
        }
        const handleOnMouseUp = () => {
            setCursor(CursorState.GRAB)
            changeMode()
        }

        const eventEmitter = new EventEmitter()
        eventEmitter.on('viewReady', handleViewReady)
        eventEmitter.on('mouseup', handleOnMouseUp)
        options.width = width
        options.height = height
        panoPlayer.current = new PanoModule({
            ...options,
            selector: ref.current,
            eventEmitter,
            clearSelectorHTML: false,
        })
    }

    useEffect(() => {
        const exitHandler = e => {
            //fullscreenElement is not supported in IE 11
            //https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
            if (
                !document.fullscreenElement &&
                !document['webkitIsFullScreen'] &&
                !document['mozFullScreen'] &&
                !document['msFullscreenElement']
            ) {
                changeFullScreen(false)
                changePanoFullScreen(false)
                panoPlayer.current.setFullscreen(false)
                panoPlayer.current.setSize('1341', '683')
            }
        }

        document.addEventListener('fullscreenchange', exitHandler)
        document.addEventListener('webkitfullscreenchange', exitHandler)
        document.addEventListener('mozfullscreenchange', exitHandler)
        document.addEventListener('MSFullscreenChange', exitHandler)

        return () => {
            document.removeEventListener('fullscreenchange', exitHandler)
            document.removeEventListener('webkitfullscreenchange', exitHandler)
            document.removeEventListener('mozfullscreenchange', exitHandler)
            document.removeEventListener('MSFullscreenChange', exitHandler)
        }
    }, [])

    useEffect(() => {
        if (panoPlayer.current) {
            if (fullScreen) {
                panoPlayer.current.setFullscreen(fullScreen)
                changePanoFullScreen(true)
            } else {
                changeFullScreen(false)
                changePanoFullScreen(false)
                panoPlayer.current.setFullscreen(false)
                panoPlayer.current.setSize('1341', '683')
            }
        }
    }, [fullScreen])

    useEffect(() => {
        setPanoViewer(ref.current.clientWidth, ref.current.clientHeight)
        panoPlayer.current.embed()

        return () => {
            panoPlayer?.current?.destroy()
        }
    }, [options.path])

    useEffect(() => {
        if (resize !== null) {
            panoPlayer?.current?.destroy()
            setPanoViewer('100%', '100%')
            panoPlayer.current.embed()
        }
    }, [resize])

    useEffect(() => {
        setResize(document.documentElement.clientWidth)
    }, [document?.documentElement?.clientWidth])

    useEffect(() => {
        panoPlayer?.current?.setAutoRotate(play, 0.1)
    }, [play])

    return (
        <div
            ref={ref}
            style={{
                cursor,
                ...panoContainer,
            }}
        >
            {children}
        </div>
    )
})

export default PanoPlayer
